import { AfterViewInit, Component, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CommonCacheServiceProxy, CompanyProfileServiceProxy, DropdownProjectListDto, GetAllProjectDto, ProjectServiceProxy, ProjectType, UserListDto, ProjectTypeForListView, ProjectType5, ProjectRestorMessageDto } from '@shared/service-proxies/service-proxies';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppConsts } from '@shared/AppConsts';
import { AbpSessionService, MessageService } from 'abp-ng2-module';
import { ModalDeletePopupComponent } from '@app/shared/common/modal-popup/modal-delete-popup/modal-delete-popup.component';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import { ProjectService } from './Services/project.service';
import * as xlsx from "xlsx-js-style";
import { ProjectNameServiceService } from '@app/shared/layout/themes/default/project-name-service.service';
import { DefaultLayoutService } from '@app/shared/layout/themes/default/default-layout.service';
import { formatTimespanShort, getAppDateFormatPattern } from '@shared/common/pipes/format.util';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { Table } from 'primeng/table';
import { TimesheetService } from '../time-sheet-new/services/timesheet.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ConstRoleName } from '@shared/ConstRoleNames';
const FileSaver = require("file-saver");
@Component({
    standalone: false,
    selector: 'app-projects-new',
    templateUrl: './projects-new.component.html',
    styleUrls: ['./projects-new.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectsNewComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("appModaldeletePopup")
    appModaldeletePopup: ModalDeletePopupComponent;
    @ViewChild("appModalPopup")
    appModalPopup: ModalPopupComponent;
    @ViewChild("projectsTabs", { static: false })
    projectsTabs: TabsetComponent;
    @ViewChild("appChangeRouteModalPopup")
    appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild('projectsTable', { static: false })
    projectsTable: Table;
    @ViewChild('myDrop', { static: true })
    myDrop: NgbDropdown;
    projectsData: any[] = [];
    projectsDataForListView: GetAllProjectDto[] = [];
    selectedProjects: GetAllProjectDto[];
    visible = true;
    isLoading = false;
    maxValue = 10;
    show: boolean = false;
    selectedProjectType = 'Active';
    filterText = '';
    data = [];
    head: any;
    dateFormat = this.l('dd/MM/yyyy');
    dateId: number;
    paginatorElem: any;
    date: any;
    projectSelectedType = 'Active';
    projectExcelDataArray: any;
    projectFilter: string[];
    assignedUserIdFilter: number[];
    assignedprojectIdFilter: number[];
    organizationUnitList: GetAllProjectDto[] = [];
    orgResult: GetAllProjectDto[] = [];
    filterOrganization: GetAllProjectDto[] = [];
    loadIndicatorVisible = true;
    checkBoxesMode: string;
    allMode: string;
    projectIdEdit: number;
    singleDeleteid: number;
    issingleDeleteid = false;
    selectedItemKeys: any[] = [];
    isDeletedHeaderFilter: any;
    editOption: number;
    isManager = false;
    isShown: boolean = true; // shown by default
    isShown_grid: boolean = false; // hidden by default
    isHideExport: boolean = false;
    projectType: ProjectType5 = ProjectType5.AllProjects;
    contentId: string;
    projectTypes: number;
    filterValue: any;
    deleteBunchFromAllProjectIds: number[] = [];
    isdeleteBunchFromAllProjectIds = false;
    deleteBunchFromArchiveProjectIds: number[] = [];
    isdeleteBunchFromArchiveProject = false;
    deleteSingleProjectFromArchivedProjectsId: number;
    isdeleteSingleProjectFromArchivedProjects = false;
    isHideNwPrj: boolean = false;
    IsProjectDataEmpty = false;
    editClicked = false;
    detailProjClicked = false;
    projectStatus = ['', 'New', 'Active', 'Completed', 'Closed'];
    actionsAllProject = [
        { id: 1, icon: 'la la-edit', text: 'Edit' },
        { id: 2, icon: 'la la-archive', text: 'Archive' },
        { id: 3, icon: 'la la-trash', text: 'Delete' }
    ];
    projectListUpdate: any[] = [];
    ProjectType = [
        { id: 1, name: this.l('Flat Rate Project') },
        { id: 2, name: this.l('Hourly Project') },
        { id: 3, name: this.l('Internal Project') },
    ];
    sectionToShowProjects = [{ id: 1, name: AppConsts.sectionNameForUserDisplayProject.allProject, desc: 'Active Projects' },
        { id: 2, name: AppConsts.sectionNameForUserDisplayProject.archiveProject, desc: 'Archived Projects' },
        { id: 3, name: AppConsts.sectionNameForUserDisplayProject.deleteProject, desc: 'Deleted Projects' }];
    selectedSectionToShowProjects = { name: AppConsts.sectionNameForUserDisplayProject.allProject, desc: 'Active' };
    projectArchiveAndDeleteStore: number[] = [];
    newProjTabs: number[] = [];
    projType: number;
    projEditId: number;
    loggedInUserRole: string;
    selectedUsersDrpDwn: UserListDto[] = sessionStorage.getItem('projectsUsersFilter')
        ? JSON.parse(sessionStorage.getItem('projectsUsersFilter')) : [];
    selectedProjectsDrpDwn: DropdownProjectListDto[] = sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')
        ? JSON.parse(sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')) : [];
    dateTime = new Date();
    msg: string;
    projectDataForExport: any[] = [];
    showProjectExport: boolean = false;
    isArchive: boolean = false;
    isdeleted: boolean = false;
    restoreFromArchBunch: boolean = false;
    restoreFromDeletedProjectList: boolean = false;
    isRestoreButtonDisabled: boolean = false;
    isarchiveButtonDisabled: boolean = false;
    userIds: number;
    private projectStatusSubscription: Subscription;
    constructor(private _monitorService: MonitoringService, injector: Injector, private router: Router, private _ProjectNameServiceService: ProjectNameServiceService, private _projectServiceProxy: ProjectServiceProxy, private _companyProfileServiceProxy: CompanyProfileServiceProxy, private headerTitleService: HeaderTitleService, private _abpSessionService: AbpSessionService, private toastr: ToastrService, private _messageService: MessageService, public projectService: ProjectService, private _defaultLayoutService: DefaultLayoutService, private _activatedRoute: ActivatedRoute, private _commonCacheServiceProxy: CommonCacheServiceProxy, private _timesheetService: TimesheetService) {
        super(injector);
        this.checkBoxesMode = 'always';
        this.allMode = 'page';
        this.isDeletedHeaderFilter = [{
                text: this.l('Yes'),
                value: ['isDeleted', '==', true]
            }, {
                text: this.l('No'),
                value: ['isDeleted', '==', false]
            },];
    }
    get canViewArchiveStateDropdown(): boolean {
        const roles = AppConsts.userRoleArray || [];
        return roles.includes(ConstRoleName.Admin)
            || roles.includes(ConstRoleName.SuperAdmin)
            || roles.includes(ConstRoleName.ProjectManager)
            || roles.includes(ConstRoleName.ProgramManager);
    }
    getProjectResponse() {
        this._defaultLayoutService.showType.subscribe((res: any) => {
            this.selectedProjectTypeFunction(res);
            this.markForCheck();
        });
    }
    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-ProjectNew");
        this.assignedUserIdFilter = this.selectedUsersDrpDwn.map((r) => r.id);
        this.getDateFormate();
        this.projectTypes = ProjectType.AllProjects;
        this.getUserWiseOtherShowAndHidePermissions();
        // Query param changes reuse this component instance, so react to the observable
        // instead of the snapshot to keep the header dropdown and the page in sync.
        this.projectStatusSubscription = this._activatedRoute.queryParams.subscribe(params => {
            const statusId = Number(params.id) || 1;
            this.selectedProjectTypeFunction(statusId);
            this._defaultLayoutService.selectedTabForProject(statusId);
        });
        this.getLoggedInUserDetails();
    }
    ngAfterViewInit() {
        let div = document.getElementById('dropMenu');
    }
    ngOnDestroy(): void {
        this.projectStatusSubscription?.unsubscribe();
    }
    checkIfAddProjectTabOpen() {
        if (this.newProjTabs.length < 1) {
            return false;
        }
        else {
            return true;
        }
    }
    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;
    async showChangeRouteModal() {
        var component = this;
        return new Promise<boolean>((resolve, reject) => {
            this.appChangeRouteModalPopup.show(2);
            this.projectsTabs.tabs[1].active = true;
            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }
    showVal(selected: GetAllProjectDto[]) {
        this.selectedProjects = selected ?? [];
    }
    searchbtn($event) {
        this.show = !this.show;
        if (!this.show) {
            this.projectsTable?.clear();
        }
    }

    getExportData(selectedItems: GetAllProjectDto[] = []): GetAllProjectDto[] {
        if (selectedItems?.length) {
            return selectedItems;
        }
        if (this.isShown_grid) {
            return this.filteredProjects ?? [];
        }
        return this.projectsTable?.filteredValue ?? this.projectsData ?? [];
    }

    onTableFilter() {
        this.showProjectExport = !this.getExportData()?.length;
    }
    changeRouteModalYes(event) {
        this.changeRouteResolve(true);
    }
    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }
    createProject(projectType: number) {
        this._monitorService.logEvent("createProject", { "createProject": "redirct to: app/main/projects-new/add-new-project" + this.msg + this.dateTime });
        this.projType = projectType;
        this.router.navigate([AppRoutes.projectsAdd], { queryParams: { projectType: projectType } });
    }
    createProjectInternal(projectType: number) {
        this._monitorService.logEvent("createProject", { "createProject": "redirct to: app/main/projects-new/add-internal-project" + this.msg + this.dateTime.getDate() });
        this.projType = projectType;
        this.router.navigate([AppRoutes.projectsAddInternal], { queryParams: { projectType: projectType } });
    }
    closeTab(event?: Event) {
        this._monitorService.logTrace("UI-closeTab", { "CloseTab ": "closeTab By : " + this.msg + this.dateTime });
        if (event)
            event.stopPropagation();
        this.newProjTabs = [];
        this.projectsTabs.tabs[0].active = true;
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem('Projects'),
            new BreadcrumbItem('Active Projects')
        ]));
        this.projectType = ProjectType5.AllProjects;
        this.selectedProjectType = 'Active';
        this.loadProjectsForCurrentSelection();
        if (this.detailProjClicked)
            this.router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: this.projectIdEdit, option: Number(this.projectType) } });
        if (this.editClicked)
            this.router.navigate([AppRoutes.projectsAdd], { state: { ProjectId: this.projectIdEdit, option: this.editOption, projectType: this.projectType } });
    }
    modalCancle() {
        this.editClicked = false;
        this.detailProjClicked = false;
    }
    closeTabWithPopUp(event?: Event) {
        this.projectsTabs.tabs[1].active = true;
        this.appModalPopup.show(2);
    }
    //
    // Get Date Format and bind the date with UI
    //
    getDateFormate() {
        this.dateFormat = getAppDateFormatPattern();
    }
    getLoggedInUserDetails() {
        const myprofileDetails = localStorage.getItem('MyProfileDetails');
        if (!myprofileDetails) {
            return;
        }
        try {
            const myProfileUser = JSON.parse(myprofileDetails);
            this.loggedInUserRole = myProfileUser?.designation;
        } catch {
            // ignore invalid cached profile payload
        }
    }
    //
    // Get Permission For Show And Hide From Compoany Profile But Not used Due to Userwise Permissions
    //
    getCaptureSettingForShowAndHidePermissions() {
        this._monitorService.logEvent("getCaptureSettingForShowAndHidePermissions", { "getCaptureSettingForShowAndHidePermissions": "getCaptureSettingForEditView: " + this.msg + this.dateTime });
        if (!AppConsts.getCaptureSettingForEditViewInstance) {
            this._companyProfileServiceProxy.getCaptureSettingForEditView(this._abpSessionService.tenantId).subscribe(x => {
                this.isHideNwPrj = x !== null || x != undefined ? x.isNwPrjCreate : false;
                AppConsts.getCaptureSettingForEditViewInstance = x;
                this.markForCheck();
            });
        }
        else {
            this.isHideNwPrj = AppConsts.getCaptureSettingForEditViewInstance !== null || AppConsts.getCaptureSettingForEditViewInstance != undefined ? AppConsts.getCaptureSettingForEditViewInstance.isNwPrjCreate : false;
        }
    }
    //
    // Get Permission For User Added in Manage User -> User -> Setting -> Other Setting
    //
    getUserWiseOtherShowAndHidePermissions() {
        this._monitorService.logEvent("getUserWiseOtherShowAndHidePermissions", { "getUserWiseOtherShowAndHidePermissions": "getUserTrackOtherSettingForEdit: " + this.msg + this.dateTime });
        this._commonCacheServiceProxy.getUserTrackOtherSettingForEdit(this._abpSessionService.tenantId, this._abpSessionService.userId).subscribe(x => {
            this.isHideNwPrj = x !== null || x != undefined ? x.isNwPrjCreate : false;
            AppConsts.userSettings = x;
            this.isHideExport = x !== null || x != undefined ? x.isExptSec : false;
            this.markForCheck();
        });
    }
    arrowStatus: string = 'la-angle-down';
    clikedOn(closed) {
        this.arrowStatus = !closed ? 'la-angle-down' : 'la-angle-up';
    }
    getHoursAndMin(timespan: string) {
        return formatTimespanShort(timespan);
    }
    redirectToViewPage(id: number, projectTypeId: number) {
        if (this.projectType === ProjectType5.DeletedProjects) {
            return;
        }
        this.projectIdEdit = id;
        if (this.projectsTabs.tabs.length > 1) {
            this.detailProjClicked = true;
            this.closeTabWithPopUp();
            return;
        }
        this.router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: id, option: projectTypeId } });
    }
    emptystate = false;
    getAllProjects() {
        try {
            this.selectedProjects = [];
            this.isLoading = true;
            this.spinnerService.show();
            this.emptystate = false;
            this.addNewDisappear = false;
            this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, this.projectType, this.assignedprojectIdFilter, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
                this.spinnerService.hide();
            })).subscribe(res => {
                const mapped = this.mapProjectsForDisplay(res, true);
                this.projectsTable?.clear();
                this.projectsDataForListView = mapped;
                this.projectDataForExport = mapped;
                this.projectListUpdate = mapped.slice();
                this.IsProjectDataEmpty = !mapped.length;
                this.showProjectExport = !mapped.length;
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    getAllProjectsForList() {
        try {
            this.selectedProjects = [];
            this.isLoading = true;
            this.spinnerService.show();
            this.emptystate = false;
            this.addNewDisappear = false;
            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, this.projectTypeForListView, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
                this.spinnerService.hide();
            })).subscribe(res => {
                const mapped = this.mapProjectsForDisplay(res, true);
                this.projectsTable?.clear();
                this.projectsData = mapped;
                this.projectDataForExport = mapped;
                this.projectListUpdate = mapped.slice();
                this.IsProjectDataEmpty = !mapped.length;
                this.showProjectExport = !mapped.length;
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    addNewDisappear = false;
    getAllArchiveProjects() {
        try {
            this._monitorService.logTrace("UI-getAllArchiveProjects", { "getAllArchiveProjects ": "getProjectsByUserIds: called " + this + this.dateTime });
            this.emptystate = false;
            this.addNewDisappear = false;
            this.selectedProjects = [];
            this.isLoading = true;
            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, ProjectTypeForListView.ArchivedProjects, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(res => {
                const mapped = this.mapProjectsForDisplay(res, true);
                this.projectsTable?.clear();
                this.projectsData = mapped;
                this.projectDataForExport = mapped;
                this.projectListUpdate = mapped.slice();
                this.IsProjectDataEmpty = !mapped.length;
                this.showProjectExport = !mapped.length;
                this.addNewDisappear = mapped.length === 0;
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    getAllDeletedProjects() {
        try {
            this._monitorService.logTrace("UI-getAllDeletedProjects", { "getAllDeletedProjects ": "getProjectsByUserIds:called " + this.msg + this.dateTime });
            this.emptystate = false;
            this.addNewDisappear = false;
            this.selectedProjects = [];
            this.isLoading = true;
            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, ProjectTypeForListView.DeletedProjects, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(res => {
                const mapped = this.mapProjectsForDisplay(res, false);
                this.projectsTable?.clear();
                this.projectsData = mapped;
                this.projectDataForExport = mapped;
                this.projectListUpdate = mapped.slice();
                this.IsProjectDataEmpty = !mapped.length;
                this.showProjectExport = !mapped.length;
                this.addNewDisappear = mapped.length === 0;
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    /** Map API rows once (avoid per-row table.clear / telemetry / unbounded list growth). */
    private mapProjectsForDisplay(res: any[], formatBilledHours: boolean): any[] {
        const defaultImage = 'assets/common/images/new-dashboard/default-project-bag.svg';
        return (res || []).map(x => {
            if (formatBilledHours) {
                x.billedHours = this.getHoursAndMin(x.billedHours);
            }
            if (x.projectImage === '') {
                x.projectImage = defaultImage;
            }
            x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
            return x;
        });
    }
    archiveBunchFromAllProject() {
        let temp: number[] = [];
        this.isArchive = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"));
            this.isArchive = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._projectServiceProxy.archiveProjectByList(temp).subscribe(() => {
            this.loadProjectsForCurrentSelection();
            this.toastr.success(this.l("ProjectArchivedsuccessfully"));
            this.isArchive = false;
            this.markForCheck();
        });
    }
    restoreBunchFromArchiveProject() {
        let temp: number[] = [];
        this.restoreFromArchBunch = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"));
            this.restoreFromArchBunch = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._projectServiceProxy.unArchiveProjectByList(temp).subscribe((res: ProjectRestorMessageDto[]) => {
            this.loadProjectsForCurrentSelection();
            res.forEach(x => {
                if (x.isRestored) {
                    this.toastr.success(this.l("ProjectsRestoredsuccessfully"));
                }
                else {
                    this.toastr.warning(this.l("The") + " " + x.projectName + " " + this.l("project requires an extension of its end date."));
                }
            });
            this.restoreFromArchBunch = false;
            this.markForCheck();
        });
    }
    deleteBunchFromAllProject() {
        this.isdeleteBunchFromAllProjectIds = true;
        this.isdeleted = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"));
            this.isdeleted = true;
            return;
        }
        this.selectedProjects.forEach(x => {
            this.deleteBunchFromAllProjectIds.push(x.id);
        });
        this.appModaldeletePopup.show();
    }
    undeleteBunchFromDeletedProject() {
        let temp: number[] = [];
        this.restoreFromDeletedProjectList = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"));
            this.restoreFromDeletedProjectList = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._monitorService.logEvent("undeleteBunchFromDeletedProject", { "undeleteBunchFromDeletedProject": "unDeleteProjectByList:called " + this.msg + this.dateTime });
        this._projectServiceProxy.unDeleteProjectByList(temp).subscribe(() => {
            this.loadProjectsForCurrentSelection();
            this.toastr.success(this.l("ProjectsRestoredsuccessfully"));
            this.restoreFromDeletedProjectList = false;
            this.markForCheck();
        });
    }
    deleteBunchFromArchiveProject() {
        this._monitorService.logTrace("UI-deleteBunchFromArchiveProject", { "deleteBunchFromArchiveProject ": "start: " + this.msg + this.dateTime });
        this.deleteBunchFromArchiveProjectIds = [];
        this.isdeleteBunchFromArchiveProject = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"));
            return;
        }
        this.appModaldeletePopup.show();
        this.selectedProjects.forEach(x => {
            this.deleteBunchFromArchiveProjectIds.push(x.id);
        });
    }
    //Check modal click for single/multiple/from_active/from_archieved and makes API call
    onModalYesClick(id) {
        if (this.issingleDeleteid) {
            this._projectServiceProxy.updateStatusProjectDelete(this.singleDeleteid).subscribe(() => {
                this.loadProjectsForCurrentSelection();
                this.issingleDeleteid = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                this.markForCheck();
            });
        }
        if (this.isdeleteBunchFromAllProjectIds) {
            this._projectServiceProxy.deleteProjectByList(this.deleteBunchFromAllProjectIds).subscribe(() => {
                this.loadProjectsForCurrentSelection();
                this.isdeleteBunchFromAllProjectIds = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                this.markForCheck();
            });
        }
        if (this.isdeleteBunchFromArchiveProject) {
            this._projectServiceProxy.deleteProjectByList(this.deleteBunchFromArchiveProjectIds).subscribe(() => {
                this.loadProjectsForCurrentSelection();
                this.isdeleteBunchFromArchiveProject = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                this.markForCheck();
            });
        }
        if (this.isdeleteSingleProjectFromArchivedProjects) {
            this._projectServiceProxy.updateStatusProjectDelete(this.deleteSingleProjectFromArchivedProjectsId).subscribe(() => {
                this.loadProjectsForCurrentSelection();
                this.isdeleteSingleProjectFromArchivedProjects = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                this.markForCheck();
            });
        }
    }
    toggleShow() {
        if (this.isShown_grid) {
            this.isShown_grid = false;
            this.isShown = true;
        }
        else if (this.isShown) {
            this.isShown_grid = true;
            this.isShown = false;
        }
        this.loadProjectsForCurrentSelection();
    }
    textForClass: string = 'la-angle-down';
    onOpenChange(data: boolean): void {
        this.textForClass = data ? 'la-angle-up' : 'la-angle-down';
    }
    //Project Type Selection Active/Archieved/Deleted
    selectedProjectTypeFunction(id: number) {
        if (id === 2) {
            this.projectType = ProjectType5.ArchivedProjects;
            this.selectedProjectType = 'Archived';
            this.headerTitleService.setPageTitle(new HeaderTitle([new BreadcrumbItem('Projects'), new BreadcrumbItem('Archived Projects')]));
        } else if (id === 3) {
            this.projectType = ProjectType5.DeletedProjects;
            this.selectedProjectType = 'Deleted';
            this.headerTitleService.setPageTitle(new HeaderTitle([new BreadcrumbItem('Projects'), new BreadcrumbItem('Deleted Projects')]));
        } else {
            this.projectType = ProjectType5.AllProjects;
            this.selectedProjectType = 'Active';
            this.headerTitleService.setPageTitle(new HeaderTitle([new BreadcrumbItem('Projects'), new BreadcrumbItem('Active Projects')]));
        }
        this.loadProjectsForCurrentSelection();
    }
    //Keeps the selected status in the URL so list/grid and the header dropdown stay in sync
    changeProjectType(id: number) {
        this._defaultLayoutService.selectedTabForProject(id);
        const currentId = Number(this._activatedRoute.snapshot.queryParams.id) || 1;
        if (currentId === id) {
            this.selectedProjectTypeFunction(id);
            return;
        }
        this.router.navigate([], {
            relativeTo: this._activatedRoute,
            queryParams: { id: id },
            queryParamsHandling: 'merge'
        });
    }
    //Reloads the view that is currently visible using the selected status
    loadProjectsForCurrentSelection() {
        if (this.isShown_grid) {
            this.getAllProjects();
            return;
        }
        if (this.projectType === ProjectType5.ArchivedProjects) {
            this.getAllArchiveProjects();
        }
        else if (this.projectType === ProjectType5.DeletedProjects) {
            this.getAllDeletedProjects();
        }
        else {
            this.getAllProjectsForList();
        }
    }
    private get projectTypeForListView(): ProjectTypeForListView {
        if (this.projectType === ProjectType5.ArchivedProjects) {
            return ProjectTypeForListView.ArchivedProjects;
        }
        if (this.projectType === ProjectType5.DeletedProjects) {
            return ProjectTypeForListView.DeletedProjects;
        }
        return ProjectTypeForListView.AllProjects;
    }
    checkIfContains() {
        this.projectsData = this.projectListUpdate;
        let tempData1 = [];
        this.projectsData.forEach(x => {
            if (x.name.toLowerCase().includes(this.filterText.toLowerCase())) {
                tempData1.push(x);
            }
        });
        this.projectsData = [];
        this.projectsData = tempData1;
        if (this.filterText.length <= 0) {
            this.projectsData = this.projectListUpdate;
        }
    }
    filterByNew() {
        this.projectsData = this.projectsData.sort((a, b) => new Date(b.startDate.toString()).getTime() - new Date(a.startDate.toString()).getTime());
    }
    filterByOld() {
        this.projectsData = this.projectsData.sort((a, b) => new Date(a.startDate.toString()).getTime() - new Date(b.startDate.toString()).getTime());
    }
    filterByProject(selectedProjects: DropdownProjectListDto[]) {
        this._monitorService.logEvent("filterByProject", { "filterByProject": "filter action on project: " + this.msg + this.dateTime });
        if (!selectedProjects) {
            this.assignedprojectIdFilter = undefined;
            sessionStorage.removeItem('projectsProjectsFilter');
        }
        else {
            if (Array.isArray(selectedProjects)) {
                this.assignedprojectIdFilter = selectedProjects?.map(r => r.id);
                this.selectedProjectsDrpDwn = selectedProjects;
                sessionStorage.setItem('projectsProjectsFilter', JSON.stringify(this.selectedProjectsDrpDwn));
            }
        }
        if (this.assignedprojectIdFilter.length === 0 || this.assignedprojectIdFilter === undefined) {
            this.loadProjectsForCurrentSelection();
        }
        else {
            this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, this.projectType, this.assignedprojectIdFilter, this.filterText, this.isManager).subscribe(res => {
                const mapped = this.mapProjectsForDisplay(res, false);
                if (this.isShown_grid) {
                    this.projectsDataForListView = mapped;
                }
                else {
                    this.projectsData = mapped;
                }
                this.projectListUpdate = mapped.slice();
                this.markForCheck();
            });
        }
    }
    filterByUser(selectedUser: UserListDto[]) {
        this._monitorService.logEvent("filterByUser", { "filterByUser": "filterByUser: " + this.msg + this.dateTime });
        if (!selectedUser) {
            this.assignedUserIdFilter = undefined;
            sessionStorage.removeItem('projectsUsersFilter');
        }
        else {
            if (Array.isArray(selectedUser)) {
                this.assignedUserIdFilter = selectedUser?.map(r => r.id);
                this.selectedUsersDrpDwn = selectedUser;
                sessionStorage.setItem('projectsUsersFilter', JSON.stringify(this.selectedUsersDrpDwn));
            }
        }
        this.loadProjectsForCurrentSelection();
    }
    i: number = 0;
    showdropdown(id: any) {
        let div = document.getElementById(id);
        this.i = this.i + 1;
        if (this.i == 1) {
            div.style.display = 'none';
        }
        if (div.style.display === 'none') {
            div.style.display = 'block';
        }
        else {
            div.style.display = 'none';
        }
        let x = document.getElementById('projectbtn');
        x.classList.toggle('up-arrow');
    }
    closeDropDownMenu(id) {
        let div = document.getElementById(id);
        div.style.display = 'none';
        let x = document.getElementById('projectbtn');
        x?.classList?.remove('up-arrow');
    }
    editSingleProjectFromAllProjects(id: number, projectTypeId: number) {
        this._monitorService.logEvent("editSingleProjectFromAllProjects", { "editSingleProjectFromAllProjects": "redirect to:app/main/projects-new/edit-project" + this.msg + this.dateTime });
        this.projectIdEdit = id;
        this.projectService.setProjectId(projectTypeId);
        this.editOption = 1;
        this.myDrop?.close();
        if (this.projectsTabs.tabs.length > 1) {
            this.editClicked = true;
            this.closeTabWithPopUp();
            return;
        }
        if (projectTypeId != 3)
            this.router.navigate([AppRoutes.projectsEdit, this.projectIdEdit]);
        else
            this.router.navigate([AppRoutes.projectsEditInternal, this.projectIdEdit]);
    }
    editProjectEvent(container: any) {
        this.projectIdEdit = container.data.id;
        this.editOption = 1;
        this.router.navigate([AppRoutes.projectsAdd], { state: { ProjectId: this.projectIdEdit, option: this.editOption } });
    }
    deleteSingleProjectFromAllProjects(id: number, myDrop) {
        myDrop.close();
        this.singleDeleteid = id;
        this.issingleDeleteid = true;
        this.appModaldeletePopup.show();
    }
    unarchiveSingleProjectFromArchivedProjects(id: number) {
        this._projectServiceProxy.updateStatusProjectUnArchive(id).subscribe((res: ProjectRestorMessageDto) => {
            this.loadProjectsForCurrentSelection();
            if (res.isRestored) {
                this.toastr.success(this.l("ProjectRestoredsuccessfully"));
            }
            else {
                this.toastr.warning(this.l("The") + " " + res.projectName + " " + this.l("project requires an extension of its end date."));
            }
            this.markForCheck();
        });
    }
    updateStatusProjectArchive;
    archiveSingleProjectFromActiveProjects(id: number, myDrop) {
        this._monitorService.logEvent("archiveSingleProjectFromActiveProjects", { "archiveSingleProjectFromActiveProjects": "updateStatusProjectArchive:called " + this.msg + this.dateTime.getDate() });
        this.myDrop?.close();
        this._projectServiceProxy.updateStatusProjectArchive(id).subscribe(() => {
            this.loadProjectsForCurrentSelection();
            this.toastr.success(this.l("ProjectArchivedsuccessfully"));
            this.markForCheck();
        });
    }
    deleteSingleProjectFromArchivedProjects(id: number, myDrop) {
        this.deleteSingleProjectFromArchivedProjectsId = id;
        this.isdeleteSingleProjectFromArchivedProjects = true;
        this.appModaldeletePopup.show();
        myDrop.close();
    }
    get filteredProjects(): any[] {
        return this.projectsDataForListView.filter((item) => item.name.toLowerCase().includes(this.filterText.toLowerCase()));
    }
    restoreSingleProjectFromDeletedProjects(id: number) {
        this._monitorService.logEvent("restoreSingleProjectFromDeletedProjects", { "restoreSingleProjectFromDeletedProjects": "updateStatusProjectUnDelete: " + this + this.msg + this.dateTime });
        this._projectServiceProxy.updateStatusProjectUnDelete(id).subscribe(() => {
            this.loadProjectsForCurrentSelection();
            this.toastr.success(this.l("ProjectRestoredsuccessfully"));
            this.markForCheck();
        });
    }
    onExporting() {
        this.exportProjectsToExcel();
        return;
    }
    //Date Format Check
    changeDateFormatAsCompanyProfile(dateVal) {
        let formattedDate;
        if (this.dateFormat == 'dd/MM/yyyy') {
            formattedDate = moment(new Date(dateVal.toString())).format("DD MMM YYYY");
        }
        else if (this.dateFormat == 'MM/dd/yyyy') {
            formattedDate = moment(new Date(dateVal.toString())).format("MMM DD YYYY");
        }
        else {
            formattedDate = moment(new Date(dateVal.toString())).format("YYYY DD MMM");
        }
        let formattedCreationTime = new Date(formattedDate as any);
        return formattedCreationTime;
    }
    //Export Project Data to Excel
    exportProjectsToExcel(selectedItems = []) {
        try {
            const filteredData = this.getExportData(selectedItems);
                this._monitorService.logTrace("UI-exportProjectsToExcel", { "exportProjectsToExcel ": "export Project In Excel: " + this + this.msg + this.dateTime });
                let projectStatusname;
                let projectBillingStatusType;
                const workbook: xlsx.WorkBook = xlsx.utils.book_new();
                let saveFiletitle = '';
                if (this.selectedProjectType === 'Active') {
                    saveFiletitle = "Active";
                }
                else if (this.selectedProjectType === 'Archived') {
                    saveFiletitle = "Archived";
                }
                else {
                    saveFiletitle = "Deleted";
                }
                const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
                xlsx.utils.sheet_add_aoa(worksheet, [[saveFiletitle + " Projects List"]], { origin: "A1" });
                xlsx.utils.sheet_add_aoa(worksheet, [['Project Name', 'Program Manager', 'Project Manager', 'Client Name', 'Client Contact', 'Project Status', 'Billing Status', 'Billed Hour', 'Completion Percentage', 'Start Date', 'End Date', 'Description'
                    ]], {
                    origin: "A2",
                });
                this.projectsData = [];
                selectedItems.length == 0 ? this.projectsData = filteredData : this.projectsData = selectedItems;
                if (this.projectsData.length > 0) {
                    let data = this.projectsData.map((x) => {
                        if (x.projectStatus == 1) {
                            projectStatusname = 'New';
                        }
                        else if (x.projectStatus == 2) {
                            projectStatusname = 'Active';
                        }
                        else if (x.projectStatus == 3) {
                            projectStatusname = 'Completed';
                        }
                        else if (x.projectStatus == 4) {
                            projectStatusname = 'Closed';
                        }
                        if (x.projectBillingType == 1) {
                            projectBillingStatusType = 'Billable';
                        }
                        else if (x.projectBillingType == 2) {
                            projectBillingStatusType = 'Non-Billable';
                        }
                        let formattedstartDateStr = this.changeDateFormatAsCompanyProfile(x.startDate);
                        let formattedendDateStr = this.changeDateFormatAsCompanyProfile(x.endDate);
                        let arr = [x.name, x.assignedProgramManagerName ? x.assignedProgramManagerName : '-', x.projectManagers ? x.projectManagers : '-', x.clientName ? x.clientName : '-', x.clientContact ? x.clientContact : '-', projectStatusname, projectBillingStatusType, (this._timesheetService.getFormattedHoursAbove24Hrs(x.billedHours)), x['ProgressPercentage'], formattedstartDateStr, formattedendDateStr, x.description ? x.description : '-'];
                        return arr;
                    });
                    if (this.loggedInUserRole == "Employee,") {
                        xlsx.utils.sheet_add_aoa(worksheet, [['Project Name', 'Client Name', 'Start Date', 'End Date', 'Billed Hour',
                                'Status']], {
                            origin: "A2",
                        });
                        this.projectsData = filteredData;
                        data = this.projectsData.map((x) => {
                            if (x.projectStatus == 1) {
                                projectStatusname = 'New';
                            }
                            else if (x.projectStatus == 2) {
                                projectStatusname = 'Active';
                            }
                            else if (x.projectStatus == 3) {
                                projectStatusname = 'Completed';
                            }
                            else if (x.projectStatus == 4) {
                                projectStatusname = 'Closed';
                            }
                            let formattedstartDateStr = this.changeDateFormatAsCompanyProfile(x.startDate);
                            let formattedendDateStr = this.changeDateFormatAsCompanyProfile(x.endDate);
                            let arr = [x.name, x.clientName ? x.clientName : '-', formattedstartDateStr, formattedendDateStr, (x.billedHours), projectStatusname];
                            return arr;
                        });
                    }
                    xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A3" });
                    worksheet["!cols"] = [
                        { width: 25 },
                        { width: 25 },
                        { width: 25 },
                        { width: 20 },
                        { width: 20 },
                        { width: 15 },
                        { width: 15 },
                        { width: 15 },
                        { width: 21 },
                        { width: 15 },
                        { width: 15 },
                        { width: 25 }
                    ];
                    for (let i in worksheet) {
                        if (typeof worksheet[i] != "object")
                            continue;
                        let cell = xlsx.utils.decode_cell(i);
                        worksheet[i].s = {
                            font: {
                                name: "Calibri",
                                sz: 11,
                                color: { rgb: "000000" },
                            },
                            border: {
                                top: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                bottom: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                left: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                right: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                            },
                        };
                        if (cell.r == 1) {
                            worksheet[i].s.font.bold = true;
                            worksheet[i].s.fill = {
                                patternType: "solid",
                                fgColor: { rgb: "DDDDDD" },
                            };
                        }
                        if (cell.r == 0) {
                            worksheet[i].s.font.bold = true;
                            worksheet[i].s.font.u = true;
                            worksheet[i].s.font.sz = 12;
                            worksheet[i].s.fill = {
                                patternType: "solid",
                                fgColor: { rgb: "FFFFFF" },
                            };
                            worksheet[i].s.alignment = {
                                vertical: "center",
                                horizontal: "center",
                                wrapText: '1',
                            };
                        }
                    }
                    for (var i in worksheet) {
                        if (typeof worksheet[i] != 'object')
                            continue;
                        let cell = xlsx.utils.decode_cell(i);
                        if (cell.c == 4) {
                            worksheet[i].z = '0.00';
                        }
                    }
                    // Merge and center cells A1 to F1
                    worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }];
                    xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
                    const excelBuffer: any = xlsx.write(workbook, {
                        bookType: "xlsx",
                        type: "array",
                    });
                    let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const data2: Blob = new Blob([excelBuffer], {
                        type: EXCEL_TYPE,
                    });
                    let saveFileName = '';
                    if (this.selectedProjectType === 'Active') {
                        saveFileName = "Active";
                    }
                    else if (this.selectedProjectType === 'Archived') {
                        saveFileName = "Archived";
                    }
                    else {
                        saveFileName = "Deleted";
                    }
                    this.projectsData = this.projectDataForExport;
                    FileSaver.saveAs(data2, saveFileName + " Projects List");
                }
                else {
                    this.projectsData = this.projectDataForExport;
                }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    //Export Project Data to Pdf
    exportGridPdf(selectedItems = []) {
        try {
            const filteredData = this.getExportData(selectedItems);
                this._monitorService.logTrace("UI-exportGridPdf", { "exportGridPdf ": "PDF export: " + this + this.msg + this.dateTime });
                let projectStatusname;
                let projectBillingStatusType;
                this.head = [['Project Name', 'Program Manager', 'Project Manager', 'Client Name', 'Client Contact', 'Project Status', 'Billing Status', 'Billed Hour', 'Completion Percentage', 'Start Date', 'End Date', 'Description']];
                this.projectExcelDataArray = [];
                this.projectsData = [];
                selectedItems.length == 0 ? this.projectsData = filteredData : this.projectsData = selectedItems;
                if (this.projectsData.length > 0) {
                    this.projectsData.forEach(x => {
                        if (x.endDate) {
                            this.date = (x.endDate).toLocaleString();
                        }
                        if (x.projectStatus == 1) {
                            projectStatusname = 'New';
                        }
                        else if (x.projectStatus == 2) {
                            projectStatusname = 'Active';
                        }
                        else if (x.projectStatus == 3) {
                            projectStatusname = 'Completed';
                        }
                        else if (x.projectStatus == 4) {
                            projectStatusname = 'Closed';
                        }
                        if (x.projectBillingType == 1) {
                            projectBillingStatusType = 'Billable';
                        }
                        else if (x.projectBillingType == 2) {
                            projectBillingStatusType = 'Non-Billable';
                        }
                        this.data = [x.name, x.assignedProgramManagerName ? x.assignedProgramManagerName : '-', x.projectManagers, x.clientName, x.clientContact ? x.clientContact : '-', projectStatusname, projectBillingStatusType, (x.billedHours), x['ProgressPercentage'], (x.startDate).toFormat('dd/MM/yyyy').toLocaleString(), (x.endDate).toFormat('dd/MM/yyyy').toLocaleString(), x.description ? x.description : '-'];
                        this.projectExcelDataArray.push(this.data);
                    });
                    if (this.loggedInUserRole == "Employee,") {
                        this.head = [['Project Name', 'Client Name', 'Hour Logged', 'Billed Hour',
                                'End Date',]];
                        this.projectExcelDataArray = [];
                        this.projectsData.forEach(x => {
                            if (x.endDate)
                                this.date = (x.endDate).toLocaleString();
                            this.data = [x.name, x.clientName, , this.date];
                            this.projectExcelDataArray.push(this.data);
                        });
                    }
                    let saveFileName = '';
                    let fileTitle = '';
                    if (this.selectedProjectType === 'Active') {
                        saveFileName = "Active";
                        fileTitle = "Active";
                    }
                    else if (this.selectedProjectType === 'Archived') {
                        saveFileName = "Archived";
                        fileTitle = "Archived";
                    }
                    else {
                        saveFileName = "Deleted";
                        fileTitle = "Deleted";
                    }
                    const doc = new jsPDF("l", "pt");
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const titleText = fileTitle + ' Project List';
                    doc.setFontSize(14);
                    const textWidth = doc.getTextWidth(titleText);
                    const centerX = (pageWidth - textWidth) / 2;
                    doc.text(titleText, centerX, 20);
                    doc.setFontSize(11);
                    doc.setTextColor(100);
                    (doc as any).autoTable({
                        head: this.head,
                        body: this.projectExcelDataArray,
                        theme: 'striped',
                        tableLineColor: [189, 195, 199],
                        startY: 30,
                        margin: {
                            top: 25
                        },
                        didDrawCell: data => {
                        }
                    });
                    this.projectsData = this.projectDataForExport;
                    doc.save(saveFileName + ' Projects List.pdf');
                }
                else {
                    this.projectsData = this.projectDataForExport;
                }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    //project progressbar calculation
    productivityBarCalculation(startD: Date, endD: Date) {
        if (!startD || !endD)
            return 0;
        let progressBar = 0;
        var startDate = new Date(startD.toString());
        var endDate = new Date(endD.toString());
        const PresentDay = new Date();
        if ((startDate > endDate) || (startDate > PresentDay)) {
            progressBar = 0;
        }
        else if (PresentDay > endDate) {
            progressBar = 100;
        }
        else {
            progressBar = (PresentDay.getTime() - startDate.getTime()) * 100 / (endDate.getTime() - startDate.getTime());
        }
        progressBar = Math.floor(progressBar);
        return progressBar;
    }
    displayOnDropdown(): string {
        if (this.contentId == 'Active') {
            return "Active";
        }
        else if (this.contentId == 'Archived') {
            return "Archive";
        }
        else
            return "Deleted";
    }
    openSelectedTab(value: number) {
        if (value === 1) {
            this.projectTypes = ProjectType.AllProjects;
            this.projectSelectedType = 'Active';
        }
        if (value === 2) {
            this.projectTypes = ProjectType.ArchivedProjects;
            this.projectSelectedType = 'Archived';
        }
        if (value === 3) {
            this.projectTypes = ProjectType.DeletedProjects;
            this.projectSelectedType = 'Deleted';
        }
    }
    onClickCard(event: string) {
        this._ProjectNameServiceService.createCard(event);
    }
    getHours(timespan: string) {
        if (!timespan)
            return '00h 00m';
        let hours = parseInt(timespan.split(":")[0]);
        return `${hours < 10 ? "0" + hours : hours}`;
    }
    getMins(timespan: string) {
        if (!timespan)
            return '00h 00m';
        let min = parseInt(timespan.split(":")[1]);
        return `${min < 10 ? "0" + min : min}`;
    }
    onExportButtonChange(val: any) {
        switch (val) {
            case 1: // Export all data to PDF
                this.exportGridPdf();
                break;
            case 2: // Export selected data to PDF
                this.exportGridPdf(this.selectedProjects);
                break;
            case 3: // Export all data to Excel
                this.exportProjectsToExcel();
                break;
            case 4: // Export selected data to Excel
                this.exportProjectsToExcel(this.selectedProjects);
                break;
        }
    }
}
